/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./details.scss";
import MovieList from "../movieList/movieList";
import { fetchSimilliarMovies } from "../../store/similiar/actions";
import { connect } from "react-redux";

const Details = ({ details, fetchSimilliarMovies, similliar }) => {
  const {
    title,
    poster_path,
    overview,
    tagline,
    runtime,
    vote_average,
    release_date,
    id
  } = details;
  useEffect(() => {
    fetchSimilliarMovies(id);
  }, []);

  return (
    <>
      <div className="details-wrap">
        <img
          className="details-poster"
          src={`https://image.tmdb.org/t/p/w500/${poster_path}`}
          alt="poster"
        />
        <div className="details">
          <h1 className="details-title">
            {title}{" "}
            <span className="details-date">({release_date.slice(0, 4)})</span>
          </h1>
          <span className="details-tagline">{tagline}</span>
          <p className="details-overview">{overview}</p>
          <div className="additional">
            <div className="add-details runtime">
              Runtime: <span>{runtime} minutes</span>
            </div>
            <div className="add-details rate">
              Rate: <span>{vote_average}/10</span>
            </div>
          </div>
        </div>
      </div>
      <h6 className="similliar-title">Similliar</h6>
      <MovieList movies={similliar} />
    </>
  );
};

const mapState = state => {
  return {
    similliar: state.similliar.moviesSimilliar,
    loading: state.similliar.loading,
    error: state.similliar.loading
  };
};

const mapDispatch = {
  fetchSimilliarMovies
};

export default connect(mapState, mapDispatch)(Details);
